module.exports = __webpack_public_path__ + "img/icon-trash-disable.b309fe6d.svg";